module.exports = __webpack_public_path__ + "img/culture.17a003ef.png";